import { resolveAuthToken } from './authToken';

// Small fetch wrapper for the Engage session endpoints (notes, examinations, session state).
// Unlike helpers/api-client it keeps the HTTP status on errors (so callers can treat 404 as
// "endpoint not deployed yet"), handles 204 No Content, and never logs the user out.

export class ApiError extends Error {
  constructor(status, message, body) {
    super(message || `Request failed (${status})`);
    this.name = 'ApiError';
    this.status = status;
    this.body = body;
  }
}

export const isNotFound = (error) => error?.status === 404;
export const isNotAvailable = (error) => [404, 405, 501].includes(error?.status);

export const sessionApi = async (endpoint, { method = 'GET', body, signal } = {}) => {
  const token = resolveAuthToken();
  const headers = { Accept: 'application/json' };
  if (body !== undefined) headers['Content-Type'] = 'application/json';
  if (token) headers.Authorization = `token ${token.token}`;
  const response = await window.fetch(`${process.env.REACT_APP_CORE_API_URL}/${endpoint.replace(/^\//, '')}`, {
    method,
    headers,
    body: body === undefined ? undefined : JSON.stringify(body),
    signal,
  });
  if (response.status === 204) return null;
  const text = await response.text();
  let data = null;
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = text;
    }
  }
  if (!response.ok) {
    const message = (data && (data.detail || data.error || (typeof data === 'string' && data.length < 200 ? data : null))) || null;
    throw new ApiError(response.status, message, data);
  }
  return data;
};

export const appointmentPath = (appointmentId, suffix = '') => `api/appointments/${appointmentId}/${suffix}`;
